import { FormInput } from '../../..';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import InfoFormProps from '../InfoFormProps';
import React from 'react';
import { observer } from 'mobx-react';

const ProjectNumberField = ({ translate, infoModel, disabled }: InfoFormProps) => {
  const label = translate(x => x.general.airdome.projectNumber);

  return <FormInput {...{
    model: new FormInputModel({
      label,
      readonly: disabled,
      validationSchema: infoModel.getProjectNumberSchema().label(label),
      placeholder: label,
      handleValueModel: new HandleValueModel({
        setValue: infoModel.projectNumber.setValue,
        inputType: 'text'
      }),
      inputId: 'ProjectNumberField',
      value: infoModel.projectNumber.Value || ''
    })
  }} />;
};

export default observer(ProjectNumberField);
